"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactHotToast = require("react-hot-toast");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var AppToaster = function AppToaster() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHotToast.Toaster, {
    position: "top-right",
    containerStyle: {
      zIndex: "var(--layer-toast)"
    },
    toastOptions: {
      duration: 4000
    },
    "data-sentry-element": "Toaster",
    "data-sentry-component": "AppToaster",
    "data-sentry-source-file": "AppToaster.tsx"
  });
};
var _default = exports.default = AppToaster;